import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://oxtaonahlgumeveddjly.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im94dGFvbmFobGd1bWV2ZWRkamx5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDI4MjAxNzgsImV4cCI6MjAxODM5NjE3OH0.WQ7E51k-lpsrfs1dX1uhRu07H7JY2kKLxLUhJWDXSlA';

export const supabase = createClient(supabaseUrl, supabaseKey);